import { TextField, TextFieldProps } from '@mui/material';
import { useField } from 'formik';

type Value = string | number | undefined;

interface Props extends Omit<TextFieldProps, 'ref' | 'onChange'> {
    name: string;
    defaultValue?: Value;
    value?: Value;
}

export const FormTextField = ({ size, rows, ...props }: Props) => {
    const [field, meta] = useField(props);

    return (
        <TextField
            size={size}
            rows={rows}
            error={meta.touched && Boolean(meta.error)}
            helperText={meta.touched && meta.error}
            {...props}
            {...field}
        />
    );
};
